//-----------------------------------
// footer-new.js
//-----------------------------------
import $ from 'jquery';
import axios from 'axios'

export let footer = {
    init() {
        // Footer Accordion Click Event 
        $('.FooterNav-trigger').click(function(){
            if( $(this).hasClass('show') ){
                $(this).siblings('ul').removeClass('show');
                $(this).removeClass('show');
            }else{
                $(this).addClass('show');
                $(this).siblings('ul').addClass('show');
            }
        })

        // Footer Signup 
        $('.FooterSignup-input').on('click', function(){
            $('.FooterSignup-attvHidden').slideDown('fast');
        });
        $('.FooterSignup-btnAttv').on('click', function(e){
            e.preventDefault();
            if ($('input.FooterSignup-check').is(':checked')) {
                let the_number = $('.FooterSignup-input').val();
                let zapWebhook = 'https://hooks.zapier.com/hooks/catch/2731784/3b0a92b/'
                the_number = the_number.replace(/-/g,'');
                console.log(the_number)
                let digits = the_number.replace(/[^0-9]/g,'').length
                console.log(digits)
                //check that it at least looks like a viable phone number?
                if (digits < 10){
                    $('.FooterSignup-error').text('Enter a valid ten digit phone number').show();
                } else {
                    $('.FooterSignup-error').text('').show();
                    let the_payload = {
                        "user": {
                            "phone": the_number
                        }   
                    };
                    console.log(the_payload)
                    the_payload = JSON.stringify( the_payload );
                    axios.post(zapWebhook, the_payload)
                        .then(function (response) {
                             console.log(response)
                            $('.FooterSignup-success').show();
                            $('.FooterSignup-wrapAttv').hide();
                        })
                        .catch(function (error) {
                        console.log(error);
                        $('.FooterSignup-error').text('oops, something went wrong.').show();
                        });
                }
            }else{
                $('.FooterSignup-error').text('Check the box before proceeding').show();
            }  
        });
    }
}